export default __webpack_public_path__ + "media/images/colors_32-d6d34899deca0d1693ae4ccf933a61e7.png";